import { TableCell, TableRow, Tooltip } from '@mui/material';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../../components/shared/useUser';
import { SystemResponse } from '../../../../app/services/api/generated';

type Props = {
  system: SystemResponse;
};

const SystemItemRow: FC<Props> = ({ system }) => {
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['SystemUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/admin/systems/edit/${system.id}`);
  };

  const truncateText = (text: string | undefined, maxLength: number = 40) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <TableRow
      onClick={canEdit ? handleRowClick : undefined}
      sx={{
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        <Tooltip title={system.name || ''}
          placement="top">
          <span>{truncateText(system.name)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip title={system.description || ''}
          placement="top">
          <span>{truncateText(system.description)}</span>
        </Tooltip>
      </TableCell>
      <TableCell align="center">
        {system.modules?.length ?? 0}
      </TableCell>
    </TableRow>
  );
};

export default SystemItemRow;
